import ConfigData from 'config/ConfigData';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  monthsShort: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
});
const usaTime = dayjs().tz('America/New_York');
const customOptions = [
  {
    name: 'Before',
    filterProperty: 'DATE_LT',
    showCalendar: true,
  },
  {
    name: 'After',
    filterProperty: 'DATE_GTE',
    showCalendar: true,
  },
  {
    name: 'Custom',
    hash: 'between',
    filterProperty: 'range',
    showCalendar: true,
  },
];

const UKDatesFilters = [
  {
    name: 'Date',
    searchState: 'inbox',
    description: 'Date option for monitor inbox with less options than for search results UK site only',
    pages: ['KeyUpdates', 'ParliamentaryRecord', 'Tweets', 'LibraryMaterial'],
    type: 'date',
    optionSelected: '',
    configHidden: ConfigData?.filters?.ukDate?.configHidden,
    filterName: 'dateTime',
    options: [
      {
        name: 'Today',
        filter: [dayjs().utc().startOf('day').format()],
      },
      {
        name: 'Yesterday',
        filter: [
          {
            field: 'dateTime',
            value: `${dayjs().utc().startOf('day').subtract(1, 'day').format().replace('Z', '')}`,
            operator: 'DATE_GTE',
          },
          {
            field: 'dateTime',
            value: `${dayjs().utc().startOf('day').format().replace('Z', '')}`,
            operator: 'DATE_LT',
          },
        ],
      },
      ...customOptions,
    ],
    updateFilter: true,
  },
  {
    name: 'Date',
    searchState: 'not-inbox',
    description: 'Date option for search results with complete options UK site only',
    pages: ['KeyUpdates', 'ParliamentaryRecord', 'Tweets', 'LibraryMaterial', 'Notes'],
    type: 'date',
    optionSelected: '',
    filterName: 'dateTime',
    configHidden: ConfigData?.filters?.ukDate?.configHidden,
    options: [
      {
        name: 'Today',
        filter: [dayjs().utc().startOf('day').format()],
      },
      {
        name: 'Yesterday',
        filter: [
          {
            field: 'dateTime',
            value: `${dayjs().utc().startOf('day').subtract(1, 'day').format().replace('Z', '')}`,
            operator: 'DATE_GTE',
          },
          {
            field: 'dateTime',
            value: `${dayjs().utc().startOf('day').format().replace('Z', '')}`,
            operator: 'DATE_LT',
          },
        ],
      },
      {
        name: 'Last 7 days',
        filter: [dayjs().subtract(6, 'day').utc().startOf('day').format()],
      },
      {
        name: 'Last 30 days',
        filter: [dayjs().subtract(29, 'day').utc().startOf('day').format()],
      },
      {
        name: 'Last 3 months',
        filter: [dayjs().subtract(3, 'months').add(1, 'day').utc().startOf('day').format()],
      },
      {
        name: 'Last 12 months',
        filter: [dayjs().subtract(1, 'year').add(1, 'day').utc().startOf('day').format()],
      },
      ...customOptions,
    ],
  },
];

const USADatesFilters = [
  {
    name: 'Date',
    searchState: 'inbox',
    description:
      'Date option for monitor inbox with less options than for search results USA site where we need different filters. KeyUpdates and Tweets',
    pages: ['KeyUpdates', 'Tweets'],
    type: 'date',
    optionSelected: '',
    configHidden: ConfigData?.filters?.usaDate?.configHidden,
    filterName: 'dateTime',
    options: [
      {
        name: 'Today',
        filter: [usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')],
      },
      {
        name: 'Yesterday',
        filter: [
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').subtract(1, 'day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')}`,
            operator: 'DATE_GTE',
          },
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')}`,
            operator: 'DATE_LT',
          },
        ],
      },
      ...customOptions,
    ],
    updateFilter: true,
  },
  {
    name: 'Date',
    searchState: 'not-inbox',
    description:
      'Date option for search results with complete options USA site where we need different filters. KeyUpdates and Tweets',
    pages: ['KeyUpdates', 'Tweets'],
    type: 'date',
    optionSelected: '',
    filterName: 'dateTime',
    configHidden: ConfigData?.filters?.usaDate?.configHidden,
    options: [
      {
        name: 'Today',
        filter: [usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')],
      },
      {
        name: 'Yesterday',
        filter: [
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').subtract(1, 'day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')}`,
            operator: 'DATE_GTE',
          },
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')}`,
            operator: 'DATE_LT',
          },
        ],
      },
      {
        name: 'Last 7 days',
        filter: [usaTime.subtract(6, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')],
      },
      {
        name: 'Last 30 days',
        filter: [usaTime.subtract(29, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss')],
      },
      {
        name: 'Last 3 months',
        filter: [
          usaTime.subtract(3, 'months').add(1, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss'),
        ],
      },
      {
        name: 'Last 12 months',
        filter: [
          usaTime.subtract(1, 'year').add(1, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss'),
        ],
      },
      ...customOptions,
    ],
  },
  //PARLIAMENTARY RECORD
  {
    name: 'Date',
    searchState: 'inbox',
    description:
      'Date option for monitor inbox with less options than for search results USA site where we need different filters. ParliamentaryRecord',
    pages: ['ParliamentaryRecord'],
    type: 'date',
    optionSelected: '',
    configHidden: ConfigData?.filters?.usaDate?.configHidden,
    filterName: 'dateTime',
    options: [
      {
        name: 'Today',
        filter: [usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DD')],
      },
      {
        name: 'Yesterday',
        filter: [
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').subtract(1, 'day').tz('Europe/London').format('YYYY-MM-DD')}`,
            operator: 'DATE_GTE',
          },
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DD')}`,
            operator: 'DATE_LT',
          },
        ],
      },
      ...customOptions,
    ],
    updateFilter: true,
  },
  {
    name: 'Date',
    searchState: 'not-inbox',
    description:
      'Date option for search results with complete options USA site where we need different filters. ParliamentaryRecord',
    pages: ['ParliamentaryRecord'],
    type: 'date',
    optionSelected: '',
    filterName: 'dateTime',
    configHidden: ConfigData?.filters?.usaDate?.configHidden,
    options: [
      {
        name: 'Today',
        filter: [usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DD')],
      },
      {
        name: 'Yesterday',
        filter: [
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').subtract(1, 'day').tz('Europe/London').format('YYYY-MM-DD')}`,
            operator: 'DATE_GTE',
          },
          {
            field: 'dateTime',
            value: `${usaTime.startOf('day').tz('Europe/London').format('YYYY-MM-DD')}`,
            operator: 'DATE_LT',
          },
        ],
      },
      {
        name: 'Last 7 days',
        filter: [usaTime.subtract(6, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DD')],
      },
      {
        name: 'Last 30 days',
        filter: [usaTime.subtract(29, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DD')],
      },
      {
        name: 'Last 3 months',
        filter: [usaTime.subtract(3, 'months').add(1, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DD')],
      },
      {
        name: 'Last 12 months',
        filter: [usaTime.subtract(1, 'year').add(1, 'day').startOf('day').tz('Europe/London').format('YYYY-MM-DD')],
      },
      ...customOptions,
    ],
  },
];

export { UKDatesFilters, USADatesFilters };
